import { jsx } from "react/jsx-runtime";
import { Box, styled } from "@mui/material";
const Root = styled(
  (props) => {
    return /* @__PURE__ */ jsx(Box, { component: "footer", ...props });
  },
  {
    name: "FormFooter",
    slot: "Root"
  }
)(() => ({
  gap: "var(--form-footer-gap)",
  display: "flex",
  padding: "var(--form-footer-padding)",
  flexDirection: "row",
  justifyContent: "var(--form-footer-alignment)"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
